import { useToggleEmailSync } from '@/components/Account/EmailAccounts/hooks';
import { ToggleItem } from '@/components/ToggleItem';
import type { IEmailAccount } from '@/modules/pmt/interfaces';
import { EmailAccountPopup } from '../EmailAccountPopup';

interface IEmailAccountItemProps {
  email: IEmailAccount;
  onToggledEmail: () => Promise<void>;
}

export const EmailAccountItem = ({ email, onToggledEmail }: IEmailAccountItemProps) => {
  const { showPopup, setShowPopup, isToggling, handleToggle, disconnectEmailSync } = useToggleEmailSync({
    email,
    onToggledEmail,
  });

  return (
    <ToggleItem
      title={email.emailAddress}
      toggled={email.realtimeSyncActivated}
      isToggling={isToggling}
      onToggle={handleToggle}
      popup={
        showPopup && (
          <EmailAccountPopup
            email={email}
            show={showPopup}
            onHide={() => setShowPopup(false)}
            handleDisconnect={disconnectEmailSync}
          />
        )
      }
    />
  );
};
